import React, { useState } from "react";
import Image from "../elements/Image";
import img from "../../assets/images/cards/card-inside-4.webp";
import nodatafound from "../../assets/images/nodatafound.png";
import Button from "../form/Button";

const ProductGalleryItem = ({ data }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  let defaultImage = [];
  defaultImage[0] = data?.productImages.find((image) => image.default_status === 1);
  let otherImages = data?.productImages.filter((image) => image.default_status !== 1);

  let rearrangedArray = defaultImage.concat(otherImages);

  return (
    <>
      {rearrangedArray?.length > 0 ? (
        <div>
          <div className="xl:w-full w-full bg-white rounded-md md:px-10 px-5 py-5 shadow-md">
            <div className="relative flex space-x-4 py-4 overflow-x-auto">
              <div className="flex space-x-4 w-full">
                {rearrangedArray?.map((item, index) => (
                  <div key={index} className="space-y-1 flex-shrink-0">
                    <div className="w-36 aspect-[2/3] overflow-hidden cursor-pointer relative group">
                      <div className="object-contain">
                        <Image src={item?.imageUrl} alt="" classes="w-full h-full object-contain" effect={"blur"} />
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 gap-4">
                        <Button
                          buttonHasLink={false}
                          buttonIcon={"fa fa-info-circle"}
                          buttonIconPosition={"left"}
                          buttonClasses={"!bg-primary !text-org-silver"}
                          buttonFunction={() => openModal(item?.imageUrl)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {isModalOpen && (
            <div
              className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-40"
              onClick={closeModal}>
              <div className="relative md:w-96 w-72">
                {/* <button
                  onClick={closeModal}
                  className="absolute top-2 right-2 text-white text-2xl bg-black rounded-full p-1">
                  &times;
                </button> */}
                <Image src={selectedImage} alt="Selected" classes="w-full h-full object-cover " effect={"blur"} />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center md:space-y-4 space-y-2 md:mt-8 mt-4">
          <div className="md:w-28 md:h-28 w-20 h-20 rounded-full bg-[#F0F9F4] overflow-hidden flex items-center justify-center">
            <div className="text-[#e73737] md:text-7xl text-5xl">
              <i className="fa-regular fa fa-exclamation"></i>
            </div>
          </div>
          <div className="text-cape-cod md:text-3xl text-2xl text-center">No Gallery Available.</div>
          <div className="text-concord text-base max-w-md text-center">
            Oops! No data available at the moment. Please try again later.
          </div>
        </div>
      )}
    </>
  );
};

export default ProductGalleryItem;
